import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { CalculatorCard } from "@/components/CalculatorCard";
import { calculators } from "@/data/calculators";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Receipt, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";
import { useTranslation } from "react-i18next";
import { useLanguageAwareSEO } from "@/hooks/useLanguageAwareSEO";
import { breadcrumbSchema } from "@/utils/structuredData";

export default function Tax() {
  const { t } = useTranslation();
  const taxCalculators = calculators.filter(calc => calc.category === "finance" && calc.subcategory === "Tax");

  useLanguageAwareSEO([
    (lang) => breadcrumbSchema([
      { name: "Home", url: "https://calclab.app" },
      { name: t('categories.pages.tax.title'), url: "https://calclab.app/tax" }
    ], lang)
  ]);

  return (
    <PageLayout>
      <div className="space-y-8">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <Receipt className="h-16 w-16 text-primary" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight">{t('categories.pages.tax.title')}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('categories.pages.tax.description')}
          </p>
        </div>

        <Card className="border-primary/20">
          <CardHeader>
            <CardTitle>{t('categories.pages.tax.cardTitle')}</CardTitle>
            <CardDescription>
              {t('categories.pages.tax.cardDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t('categories.pages.tax.cardContent')}
            </p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {taxCalculators.map(calculator => (
            <CalculatorCard key={calculator.id} {...calculator} />
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
